module.exports = __webpack_public_path__ + "img/wallpapers.b5722718.svg";